import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-excel-file-name-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './excel-file-name-modal.component.html',
  styleUrl: './excel-file-name-modal.component.scss'
})
export class ExcelFileNameModalComponent implements OnInit {
  @Input() defaultFileName: string = '';
  name: string = ''
  @Output() fileNameEmitter = new EventEmitter<string>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.name = this.defaultFileName || '';
  }

  submit() {
    if (this.name.trim()) {
      this.activeModal.close(this.name);
    } else {
      alert('Please enter a valid file name.');
    }
  }
}

